import { styled } from '@material-ui/core';

import { lightGreenBackground } from 'app/core/theme/palette';

export const Wrapper = styled('div')({
  backgroundColor: lightGreenBackground,
  paddingTop: 48,
  paddingBottom: 48,
});
